import MobileDetect from 'mobile-detect'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const MobileDetector = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const mb = new MobileDetect(window.navigator.userAgent)

    dispatch({
      type: 'GOT_PHONE_TYPE',
      payload: mb.phone()
    })
  }, [dispatch])

  return null
}

export default MobileDetector
